import React from "react"

const Codemetrics: React.FC<React.SVGAttributes<HTMLOrSVGElement>> = (
  props
) => {
  const { ...rest } = props
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="150"
      height="26"
      viewBox="0 0 150 26"
      fill="none"
      {...rest}
    >
      <path
        d="M33.0654 13.0234C33.0654 8.47403 35.9415 5.44766 40.2457 5.44766C43.7253 5.44766 46.3198 7.47193 46.8226 10.6185H44.1074C43.6045 8.91488 42.1363 7.91279 40.1853 7.91279C37.4701 7.91279 35.7605 9.87693 35.7605 13.0034C35.7605 16.1099 37.4902 18.1141 40.1853 18.1141C42.1766 18.1141 43.7051 17.0718 44.1879 15.4485H46.8629C46.2998 18.5349 43.6045 20.5792 40.125 20.5792C35.8409 20.5792 33.0654 17.6131 33.0654 13.0234Z"
        fill="white"
      />
      <path
        d="M53.2649 10.1575C56.3421 10.1575 58.5747 12.2819 58.5747 15.3684C58.5747 18.4549 56.3421 20.5793 53.2649 20.5793C50.1876 20.5793 47.955 18.4548 47.955 15.3684C47.955 12.282 50.1876 10.1575 53.2649 10.1575ZM53.2649 18.3947C54.9544 18.3947 56.1209 17.1721 56.1209 15.3684C56.1209 13.5647 54.9544 12.3421 53.2649 12.3421C51.5754 12.3421 50.4088 13.5646 50.4088 15.3684C50.4088 17.1721 51.5754 18.3947 53.2649 18.3947Z"
        fill="white"
      />
      <path
        d="M59.6629 15.4284C59.6629 12.3421 61.4731 10.1375 64.4699 10.1375C65.8577 10.1375 67.0846 10.7187 67.7081 11.7007V5.42764H70.1418V20.3386H67.8892L67.7282 18.7954C67.1249 19.9378 65.8376 20.5992 64.3291 20.5992C61.453 20.5992 59.6629 18.4948 59.6629 15.4284ZM67.688 15.3483C67.688 13.5646 66.5818 12.3221 64.8722 12.3221C63.1625 12.3221 62.1166 13.5846 62.1166 15.3483C62.1166 17.1121 63.1626 18.3545 64.8722 18.3545C66.5817 18.3545 67.688 17.132 67.688 15.3483Z"
        fill="white"
      />
      <path
        d="M71.7871 15.3884C71.7871 12.2819 73.8185 10.1375 76.735 10.1375C79.7117 10.1375 81.6023 12.1215 81.6023 15.2081V15.9496L74.1203 15.9695C74.3013 17.7132 75.2265 18.595 76.8556 18.595C78.2032 18.595 79.0882 18.0739 79.3698 17.132H81.6425C81.2201 19.2965 79.4099 20.5992 76.8154 20.5992C73.8587 20.5992 71.7871 18.4547 71.7871 15.3884ZM74.1805 14.4063H79.1686C79.1686 13.0434 78.2233 12.1416 76.755 12.1416C75.3068 12.1416 74.4219 12.9232 74.1805 14.4063Z"
        fill="white"
      />
      <path
        d="M83.2697 20.3386V10.4381H85.5223L85.7235 11.6005C86.2263 10.7788 87.2319 10.1375 88.66 10.1375C90.1684 10.1375 91.2143 10.879 91.7372 12.0213C92.2401 10.879 93.4066 10.1375 94.9151 10.1375C97.3286 10.1375 98.656 11.5804 98.656 13.8651V20.3386H96.2224V14.5065C96.2224 13.0836 95.4582 12.342 94.2916 12.342C93.1049 12.342 92.1998 13.1036 92.1998 14.727V20.3386H89.746V14.4865C89.746 13.1036 89.0018 12.3621 87.8353 12.3621C86.6688 12.3621 85.7235 13.1236 85.7235 14.727V20.3386H83.2697Z"
        fill="white"
      />
      <path
        d="M100.191 15.3884C100.191 12.2819 102.223 10.1375 105.139 10.1375C108.116 10.1375 110.007 12.1215 110.007 15.2081V15.9496L102.525 15.9696C102.706 17.7133 103.631 18.5951 105.26 18.5951C106.607 18.5951 107.492 18.074 107.774 17.1321H110.047C109.624 19.2966 107.814 20.5993 105.22 20.5993C102.263 20.5992 100.191 18.4547 100.191 15.3884ZM102.585 14.4063H107.573C107.573 13.0434 106.628 12.1416 105.159 12.1416C103.711 12.1416 102.826 12.9232 102.585 14.4063Z"
        fill="white"
      />
      <path
        d="M112.518 20.3386V12.4823H110.607V10.4381H112.518V7.35163H114.972V10.4381H116.903V12.4823H114.972V20.3386H112.518Z"
        fill="white"
      />
      <path
        d="M124.238 12.6627H123.333C121.563 12.6627 120.457 13.6047 120.457 15.5286V20.3387H118.003V10.4581H120.316L120.457 11.9011C120.879 10.9191 121.824 10.2577 123.152 10.2577C123.518 10.2587 123.883 10.3059 124.238 10.398L124.238 12.6627Z"
        fill="white"
      />
      <path
        d="M125.119 6.97086C125.119 6.67839 125.206 6.39246 125.369 6.14901C125.531 5.90557 125.763 5.71549 126.033 5.60267C126.304 5.48986 126.602 5.45934 126.891 5.51496C127.179 5.57058 127.444 5.70985 127.653 5.91527C127.862 6.12068 128.005 6.38307 128.065 6.66942C128.124 6.95578 128.098 7.25333 127.988 7.52466C127.879 7.79598 127.691 8.02896 127.449 8.19431C127.207 8.35965 126.921 8.44998 126.628 8.45392C126.43 8.45643 126.235 8.41992 126.052 8.34653C125.869 8.27313 125.703 8.16431 125.562 8.02635C125.422 7.8884 125.311 7.72407 125.235 7.54289C125.159 7.36171 125.119 7.16727 125.119 6.97086ZM125.401 10.4381H127.854V20.3386H125.401L125.401 10.4381Z"
        fill="white"
      />
      <path
        d="M134.377 10.1375C137.092 10.1375 138.943 11.6406 139.204 14.0255H136.75C136.469 12.9033 135.644 12.322 134.477 12.322C132.909 12.322 131.863 13.5044 131.863 15.3683C131.863 17.2323 132.828 18.3946 134.397 18.3946C135.624 18.3946 136.489 17.7933 136.75 16.7111H139.224C138.923 19.0159 136.992 20.5992 134.397 20.5992C131.38 20.5992 129.409 18.5148 129.409 15.3683C129.409 12.3019 131.44 10.1375 134.377 10.1375Z"
        fill="white"
      />
      <path
        d="M142.46 17.3324C142.48 18.1942 143.124 18.7354 144.25 18.7354C145.397 18.7354 146.02 18.2743 146.02 17.5529C146.02 17.0518 145.759 16.691 144.874 16.4907L143.084 16.0698C141.294 15.669 140.429 14.8273 140.429 13.244C140.429 11.2999 142.078 10.1375 144.371 10.1375C146.604 10.1375 148.112 11.4202 148.132 13.3442H145.799C145.779 12.5024 145.216 11.9613 144.27 11.9613C143.305 11.9613 142.742 12.4022 142.742 13.1437C142.742 13.705 143.184 14.0657 144.029 14.2661L145.819 14.6869C147.489 15.0677 148.333 15.8293 148.333 17.3524C148.333 19.3566 146.624 20.5992 144.17 20.5992C141.696 20.5992 140.127 19.2764 140.127 17.3324H142.46Z"
        fill="white"
      />
      <path
        d="M9.88511 23L4.53515 12.9999L9.88511 3H5.34996L0 12.9999L5.34996 23H9.88511Z"
        fill="white"
      />
      <path
        d="M14.5874 14.202L20.5803 3H16.0453L12.9629 8.76139L9.88069 3H5.3457L11.3384 14.202H14.5874Z"
        fill="white"
        fillOpacity="0.4"
      />
      <path
        d="M20.5814 23L25.9312 12.9999L20.5814 3H16.0461L21.396 12.9999L16.0461 23H20.5814Z"
        fill="white"
      />
    </svg>
  )
}

export default Codemetrics
